import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'

import { isBotArchivedSelector } from '../../../features/serverBots/selectors/isBotArchivedSelector'

export function useIsBotArchived() {
  return useSelector<RootState, boolean>(isBotArchivedSelector)
}
